import {
  COUNTRY,
  COUNTRY_LABEL,
  OTHER_COUNTRY,
  formatInstantInCountry,
} from '@/config/country';

/**
 * Los momentos de ejecución se guardan en UTC. Antes se formateaban con la zona
 * del navegador y sin decirlo, así que la misma corrida se leía a las 16:40 en
 * Montevideo y a las 14:40 en Lima, y no había forma de saber cuál era cuál.
 *
 * Ahora la hora principal es la del país del panel —la que dice el título de la
 * columna— y debajo va la del otro país.
 */
export const renderTime = (value: string) => {
  if (!value) return <></>;

  const here = formatInstantInCountry(value, COUNTRY);
  if (!here) return <></>;

  const there = formatInstantInCountry(value, OTHER_COUNTRY, {
    withDate: false,
  });

  return (
    <div className='flex flex-col'>
      <span>{here}</span>
      {there && (
        <span className='text-xs text-gray-500'>
          {there} en {COUNTRY_LABEL[OTHER_COUNTRY]}
        </span>
      )}
    </div>
  );
};
